<template>
  <div class="login-page">
    <div class="login-shell">
      <div class="brand-corner">
        <img class="brand-corner-logo" :src="pageLogo" alt="COG" @click="goHome()"/>
      </div>

      <div class="login-stage">
        <div class="stage-visual">
          <img class="stage-visual-img" :src="stageImage" alt="登录主视觉" />
        </div>

        <section class="login-card">
          <img class="login-card-logo" :src="cardLogo" alt="COG" />

          <div class="login-tabs">
            <button
              type="button"
              :class="['login-tab', { active: activeType === 'org' }]"
              @click="switchLoginType('org')"
            >
              <img :src="activeType === 'org' ? orgTabIconActive : orgTabIcon" alt="MCN机构" class="login-tab-icon" />
              <span>MCN机构</span>
            </button>
            <button
              type="button"
              :class="['login-tab', { active: activeType === 'personal' }]"
              @click="switchLoginType('personal')"
            >
              <img :src="activeType === 'personal' ? personalTabIconActive : personalTabIcon" alt="个人主播" class="login-tab-icon" />
              <span>个人主播</span>
            </button>
          </div>

          <el-form ref="loginForm" :model="loginForm" class="login-form" @submit.native.prevent>
            <div v-if="activeType === 'org'" class="form-block">
              <div class="field-label">企业名称</div>
              <el-input v-model.trim="loginForm.companyName" placeholder="请输入企业完整名称" class="field-input" />
            </div>

            <div class="form-block">
              <div class="field-label">手机号</div>
              <el-input v-model.trim="loginForm.mobile" maxlength="11" placeholder="请输入手机号" class="field-input" />
            </div>
			
			<div class="form-block">
			  <div class="field-label">图形验证码 <span class="required">*</span></div>
			  <div class="inline-row2">
			    <el-input v-model.trim="loginForm.imageCode" maxlength="6" placeholder="请输入验证码" class="field-input flex-1" />
			    <button type="button" class="captcha-box" @click="refreshCaptcha" title="点击刷新验证码">
			      <img v-if="captchaImage" :src="captchaImage" alt="图形验证码" class="captcha-image" />
			      <span v-else>加载中</span>
			    </button>
			  </div>
			</div>

            <div class="form-block">
              <div class="field-label">验证码</div>
              <div class="inline-row">
                <el-input v-model.trim="loginForm.smsCode" maxlength="6" placeholder="请输入验证码" class="field-input flex-1" />
                <button type="button" class="code-btn" :disabled="smsLoading || countdown > 0" @click="handleSendSmsCode">
                  {{ countdown > 0 ? `${countdown}s后重试` : '获取验证码' }}
                </button>
              </div>
            </div>

            

            <button type="button" class="submit-btn" :disabled="submitting" @click="handleSubmitLogin">
              {{ submitting ? '登录中...' : '登录' }}
            </button>
          </el-form>

          <div class="login-footer">
            <span>未有账号？</span>
            <button type="button" class="register-link" @click="goRegister">立即注册</button>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { getCaptcha, sendAuthSmsCode, loginAccount } from '@/api/user';

export default {
  name: 'login',
  data() {
    return {
      activeType: 'org',
      smsLoading: false,
      submitting: false,
      countdown: 0,
      countdownTimer: null,
      captchaKey: '',
      captchaImage: '',
      pageLogo: require('../../assets/img/login/l_logo2.png'),
      cardLogo: require('../../assets/img/login/l_logo.png'),
      pageBackground: require('../../assets/img/login/l_bg.png'),
      stageImage: require('../../assets/img/login/bo.png'),
      orgTabIcon: require('../../assets/img/login/jg.png'),
      orgTabIconActive: require('../../assets/img/login/jgxz.png'),
      personalTabIcon: require('../../assets/img/login/gr.png'),
      personalTabIconActive: require('../../assets/img/login/grxz.png'),
      loginForm: {
        companyName: '',
        mobile: '',
        smsCode: '',
        imageCode: ''
      }
    };
  },
  computed: {
    pageStyle() {
      return {
        backgroundImage: `url(${this.pageBackground})`
      };
    }
  },
  mounted() {
    this.refreshCaptcha();
  },
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
  },
  methods: {
    switchLoginType(type) {
      this.activeType = type;
      this.loginForm.smsCode = '';
      this.loginForm.imageCode = '';
      this.refreshCaptcha(true);
    },
    goRegister() {
      this.$router.push({ path: '/register' });
    },
    async refreshCaptcha(silent = false) {
      try {
        const response = await getCaptcha();
        this.captchaKey = response && response.key ? response.key : '';
        this.captchaImage = response && response.img ? response.img : '';
      } catch (error) {
        this.captchaKey = '';
        this.captchaImage = '';
        if (!silent) {
          this.$message.warning(error && error.message ? error.message : '图形验证码加载失败');
        }
      }
    },
    validateBaseFields() {
      if (this.activeType === 'org' && !this.loginForm.companyName) {
        this.$message.warning('请输入企业名称');
        return false;
      }

      if (!/^1\d{10}$/.test(this.loginForm.mobile)) {
        this.$message.warning('请输入正确的手机号');
        return false;
      }

      return true;
    },

    validateCaptchaFields() {
      if (!this.captchaKey || !this.captchaImage) {
        this.$message.warning('图形验证码加载失败，请刷新后重试');
        return false;
      }

      if (!this.loginForm.imageCode) {
        this.$message.warning('请输入图形验证码');
        return false;
      }

      return true;
    },
    startSmsCountdown() {
      this.countdown = 60;
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      this.countdownTimer = setInterval(() => {
        this.countdown -= 1;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
      }, 1000);
    },
    async handleSendSmsCode() {
      if (!this.validateBaseFields() || !this.validateCaptchaFields()) {
        return;
      }

      this.smsLoading = true;
      try {
        await this.requestLoginSmsCode();
        this.$message.success('验证码已发送');
        this.startSmsCountdown();
      } catch (error) {
        this.$message.warning(error && error.message ? error.message : '验证码发送失败');
        if (this.isCaptchaError(error)) {
          this.loginForm.imageCode = '';
          await this.refreshCaptcha(true);
        }
      } finally {
        this.smsLoading = false;
      }
    },
    async handleSubmitLogin() {
      if (!this.validateBaseFields()) {
        return;
      }

      if (!this.loginForm.smsCode) {
        this.$message.warning('请输入短信验证码');
        return;
      }

      this.submitting = true;
      try {
        const result = this.activeType === 'org'
          ? await this.loginAsOrg()
          : await this.loginAsPersonal();

        this.handleLoginSuccess(result);
      } catch (error) {
        this.$message.warning(error && error.message ? error.message : '登录失败');
      } finally {
        this.submitting = false;
      }
    },

    async requestLoginSmsCode() {
      return sendAuthSmsCode({
        phone: this.loginForm.mobile,
        scene: 'login',
        captcha_key: this.captchaKey,
        captcha_code: this.loginForm.imageCode
      });
    },

    async loginAsOrg() {
      return loginAccount({
        phone: this.loginForm.mobile,
        code: this.loginForm.smsCode,
        type: 'mcn',
        name: this.loginForm.companyName
      });
    },

    async loginAsPersonal() {
      return loginAccount({
        phone: this.loginForm.mobile,
        code: this.loginForm.smsCode,
        type: 'individual'
      });
    },
    isCaptchaError(error) {
      const errors = error && error.data && error.data.errors;
      return Boolean(errors && errors.captcha_code)
        || (error && error.message ? error.message.includes('图形验证码') : false);
    },
    handleLoginSuccess(response) {
      const userInfo = response && response.data ? response.data : null;
      const token = response && response.token;
      if (!token || !userInfo) {
        throw new Error('登录返回数据不完整');
      }

      localStorage.setItem('token', token);
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
      localStorage.setItem('loginType', userInfo.type || (this.activeType === 'org' ? 'mcn' : 'individual'));
      if (this.$store) {
        this.$store.commit('user/SET_TOKEN', token);
      }
      this.$message.success('登录成功');
      this.$router.push({
        path: userInfo.type === 'mcn' ? '/user/org' : '/user/personal'
      });
    },
	goHome(){
		this.$router.push({
		  path: '/'
		});
	}
  }
};
</script>

<style lang="scss" scoped>
.login-page {
  min-height: 100vh;
  background: url('../../assets/img/login/l_bg.png') center no-repeat;
  background-size: 100% 100%;
}

.login-shell {
  position: relative;
  min-height: 100vh;
  padding: 30px 52px;
}

.brand-corner {
  position: absolute;
  top: 32px;
  left: 52px;
  cursor: pointer;
}

.brand-corner-logo {
  width: 292px;
  display: block;
}

.login-stage {
  min-height: calc(100vh - 60px);
  display: grid;
  grid-template-columns: minmax(480px, 1fr) 536px;
  align-items: center;
  gap: 72px;
}

.stage-visual {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-top: 30px;
}

.stage-visual-img {
  width: min(100%, 540px);
  display: block;
  transform: translateX(-90px);
}

.login-card {
  width: 536px;
  min-height: 714px;
  padding: 58px 48px 44px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 20px 60px rgba(131, 141, 190, 0.18);
  transform: translateX(-270px);
}

.login-card-logo {
  width: 152px;
  display: block;
  margin: 0 auto;
}

.login-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-top: 34px;
  border-bottom: 1px solid #cfd3de;
  width: 260px;
}

.login-tab {
  height: 44px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 500;
  font-size: 14px;
  color: #999FB8;
}

.login-tab-icon {
  width: 16px;
  height: 16px;
  display: block;
  object-fit: contain;
}

.login-tab.active {
  border-bottom-color: #5B63F3;
  color: #5B63F3;
}

.login-form {
  margin-top: 22px;
}

.form-block {
  margin-top: 22px;
}

.field-label {
  margin-bottom: 12px;
  color: #232843;
  font-size: 15px;
}

.required {
  color: #9f6bff;
}

.inline-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 118px;
  gap: 10px;
  align-items: center;
  
}

.flex-1 {
  min-width: 0;
}

.field-input ::v-deep .el-input__inner {
	height: 45px;
	background: #F8FAFC;
	border-radius: 8px 8px 8px 8px;
	border: 1px solid #E2E8F0;
	  color: #2d3654;
	  font-size: 15px;
}


.inline-row2 ::v-deep .el-input__inner {
	border: none;
	height: 43px;
}
.inline-row2{
	display: grid;
	grid-template-columns: minmax(0, 1fr) 87px;
	gap: 10px;
	align-items: center;
	height: 45px;
	background: #F8FAFC;
	border-radius: 8px 8px 8px 8px;
	border: 1px solid #E2E8F0;
	  color: #2d3654;
	  font-size: 15px;
}

.field-input ::v-deep .el-input__inner::placeholder {
  color: #b2b9d0;
}

.field-input ::v-deep .el-input__inner:focus {
  border-color: #7a83ff;
}

.code-btn,
.captcha-box {
  height: 45px;
  border: 0;
  border-radius: 8px;
}

.code-btn {
 background: #E6E9FF;
  font-size: 14px;
  cursor: pointer;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  font-size: 14px;
  color: #4F46E5;
}
.code-btn:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.captcha-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  overflow: hidden;
  border: none;
  background: none;
  cursor: pointer;
 width: 82px;
  height: 36px;
  margin-top: 0;
}

.captcha-image {
  width: 100%;
  height: 100%;
  display: block;
}

.submit-btn {
  width: 100%;
  height: 54px;
  margin-top: 28px;
  border: 0;
  background: linear-gradient( 117deg, #518BFF 0%, #9E5DFF 100%), linear-gradient( 149deg, rgba(172,234,255,0.6) 0%, rgba(209,250,255,0) 100%);
  box-shadow: 0px 2px 10px 0px rgba(157,157,191,0.35);
  border-radius: 12px 12px 12px 12px;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
}

.submit-btn:disabled {
  cursor: not-allowed;
  opacity: 0.75;
}

.login-footer {
  margin-top: 14px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  font-size: 14px;
  color: #999FB8;
  line-height: 20px;
}

.register-link {
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  font-size: 14px;
  color: #4F46E5;
}

@media (max-width: 1200px) {
  .login-shell {
    padding: 24px;
  }

  .brand-corner {
    left: 24px;
    top: 24px;
  }

  .login-stage {
    grid-template-columns: 1fr;
    justify-items: center;
    gap: 24px;
    padding-top: 70px;
  }

  .stage-visual {
    padding-top: 0;
  }

  .stage-visual-img,
  .login-card {
    transform: none;
  }
}

@media (max-width: 640px) {
  .brand-corner-logo {
    width: 210px;
  }

  .login-card {
    min-height: auto;
    padding: 34px 20px 28px;
    border-radius: 20px;
  }

  .login-card-logo {
    width: 170px;
  }

  .login-tab {
    font-size: 14px;
  }

  .field-label {
	font-family: Source Han Sans, Source Han Sans;
	font-weight: 400;
	font-size: 14px;
	color: #1E293B;
	line-height: 20px;
	text-align: left;
  }

  .inline-row {
    grid-template-columns: 1fr;
  }

  .code-btn,
  .captcha-box,
  .field-input ::v-deep .el-input__inner {
    height: 44px;
  }
}
</style>
